import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { TCaseBlock } from "../../../../types";
import { CaseField } from "./CaseField";
import { AppInfoTooltip } from "../../../../../../common/AppInfoTooltip";
import styles from "./styles.module.css";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { selectCaseEntityMode } from "../../../../redux/selectors";

interface Props {
  caseBlock: TCaseBlock;
  handleChangeField: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | string,
    path: string,
  ) => void;
  handleClickTip: (field: string, value: string) => void;
  className?: string;
}

export const CaseBlock = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles["segment-container"], props.className)}>
      {props.caseBlock.blockTitle !== "case_transform_method" && (
        <div onClick={() => {}} className={styles["case-segment-header"]}>
          <h3 className={styles["block-title"]}>
            {t(`cases.${props.caseBlock.blockTitle}`).toLocaleUpperCase()}
          </h3>
          {props.caseBlock.tooltip && (
            <AppInfoTooltip
              title={props.caseBlock.tooltip}
              place="top"
              className={styles["case-tooltip"]}
            />
          )}
        </div>
      )}
      <div
        className={classNames(
          styles["field-block"],
          styles[`${props.caseBlock.blockTitle}`],
        )}
      >
        {props.caseBlock?.fields?.map((field) => {
          return (
            <CaseField
              key={field.path}
              field={field}
              handleChangeField={props.handleChangeField}
              handleClickTip={props.handleClickTip}
            />
          );
        })}
      </div>
    </div>
  );
};
